module.exports = __webpack_public_path__ + "media/assets/services_manager/banners/MB_PRO-5fb35503fb8cafc6bb7108962c91bc22708e6a99ba98dca43da719ca55266bc2.png";